// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"SignupFinish_pattern-gradient__us6qO","page":"SignupFinish_page__Mjcd6","icon":"SignupFinish_icon__Wi-1S"};